<section class="section" id="process">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8">
                <div class="text-center mb-5">
                    <h1 class="mb-3 ff-secondary fw-semibold lh-base">How <span class="text-primary">it's work</span>
                        creative jobs & quickly features</h1>
                    <p class="text-muted">A creative person has the ability to invent and develop original ideas,
                        especially in the arts. Like so many creative people, he was never satisfied.</p>
                </div>
            </div>
            <!-- end col -->
        </div>
        <!--end row-->
        <div class="row">
            <div class="col-lg-3 col-md-6">
                <div class="card shadow-lg">
                    <div class="card-body p-4">
                        <h1 class="fw-bold display-5 ff-secondary mb-4 text-success position-relative">
                            <div class="job-icon-effect"></div>
                            <span>1</span>
                        </h1>
                        <h6 class="fs-17 mb-2">Register Account</h6>
                        <p class="text-muted mb-0 fs-14">First, You need to make a account.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="card shadow-none">
                    <div class="card-body p-4">
                        <h1 class="fw-bold display-5 ff-secondary mb-4 text-success position-relative">
                            <div class="job-icon-effect"></div>
                            <span>2</span>
                        </h1>
                        <h6 class="fs-17 mb-2">Create Resume</h6>
                        <p class="text-muted mb-0 fs-14">Create a resume for your job.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="card shadow-none">
                    <div class="card-body p-4">
                        <h1 class="fw-bold display-5 ff-secondary mb-4 text-success position-relative">
                            <div class="job-icon-effect"></div>
                            <span>3</span>
                        </h1>

                        <h6 class="fs-17 mb-2">Find Job</h6>
                        <p class="text-muted mb-0 fs-14">Search for your dream jobs from velzon.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="card shadow-none">
                    <div class="card-body p-4">
                        <h1 class="fw-bold display-5 ff-secondary mb-4 text-success position-relative">
                            <div class="job-icon-effect"></div>
                            <span>4</span>
                        </h1>
                        <h6 class="fs-17 mb-2">Apply Job</h6>
                        <p class="text-muted mb-0 fs-14">Apply to the compnay and wait for interview.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--end container-->
</section>

<!-- start features -->
<section class="section">
    <div class="container">
        <div class="row align-items-center justify-content-lg-between justify-content-center gy-4">
            <div class="col-lg-5 col-sm-7">
                <div class="about-img-section mb-5 mb-lg-0 text-center">
                    <div class="card rounded shadow-lg inquiry-box d-none d-lg-block">
                        <div class="card-body d-flex align-items-center">
                            <div class="avatar-sm flex-shrink-0 me-3">
                                <div class="avatar-title bg-secondary-subtle text-secondary rounded-circle fs-18">
                                    <i class="ri-briefcase-2-line"></i>
                                </div>
                            </div>
                            <h5 class="fs-14 lh-base mb-0">Search Over <span
                                    class="text-secondary fw-semibold">1,00,000+</span> Jobs</h5>
                        </div>
                    </div>

                    <div class="card feedback-box">
                        <div class="card-body d-flex shadow-lg">
                            <div class="flex-shrink-0 me-3">
                                <img src="assets/images/users/avatar-10.jpg" alt="" class="avatar-sm rounded-circle">
                            </div>
                            <div class="flex-grow-1">
                                <h5 class="fs-14 lh-base mb-0">Tonya Noble</h5>
                                <p class="text-muted fs-11 mb-1">UI/UX Designer</p>

                                <div class="text-warning">
                                    <i class="ri-star-s-fill"></i>
                                    <i class="ri-star-s-fill"></i>
                                    <i class="ri-star-s-fill"></i>
                                    <i class="ri-star-s-fill"></i>
                                    <i class="ri-star-s-line"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <img src="assets/images/about.jpg" alt="" class="img-fluid mx-auto rounded-3" />
                </div>
            </div>
            <div class="col-lg-6">
                <div class="text-muted">
                    <h1 class="mb-3 lh-base">Find Your <span class="text-primary">Dream Job</span> in One
                        Place</h1>
                    <p class="ff-secondary fs-16 mb-2">The first step in finding your <b>dream job </b> is deciding
                        where to look for first-hand insight. Contact professionals who are already working in
                        industries or positions that interest you.</p>
                    <p class="ff-secondary fs-16">Schedule informational interviews and phone calls or ask for the
                        opportunity to shadow them on the job.</p>

                    <div class="vstack gap-2 mb-4 pb-1">
                        <div class="d-flex align-items-center">
                            <div class="flex-shrink-0 me-2">
                                <div class="avatar-xs icon-effect">
                                    <div class="avatar-title bg-transparent text-success rounded-circle h2">
                                        <i class="ri-check-fill"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-grow-1">
                                <p class="mb-0">Dynamic Content</p>
                            </div>
                        </div>
                        <div class="d-flex align-items-center">
                            <div class="flex-shrink-0 me-2">
                                <div class="avatar-xs icon-effect">
                                    <div class="avatar-title bg-transparent text-success rounded-circle h2">
                                        <i class="ri-check-fill"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-grow-1">
                                <p class="mb-0">Setup plugin's information.</p>
                            </div>
                        </div>
                        <div class="d-flex align-items-center">
                            <div class="flex-shrink-0 me-2">
                                <div class="avatar-xs icon-effect">
                                    <div class="avatar-title bg-transparent text-success rounded-circle h2">
                                        <i class="ri-check-fill"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-grow-1">
                                <p class="mb-0">Themes customization information</p>
                            </div>
                        </div>
                    </div>

                    <div>
                        <a href="javascript:void(0);" class="btn btn-primary">Find Your Jobs <i
                                class="ri-arrow-right-line align-bottom ms-1"></i></a>
                    </div>
                </div>
            </div>
            <!-- end col -->
        </div>
        <!-- end row -->
    </div>
    <!-- end container -->
</section>
<!-- end features -->